const accountingCatalogsModel = vm => ({
  title: vm.$gettext('Accounting Catalogs'),
  endpoint: 'accounting-catalogs',
  allowNew: true,
  allowDelete: true,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'catalog',
      label: vm.$gettext('Catalog'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext(
        '**MUST BE** one of the following values: payment_periods, invoicing_programs, customer_types, document_types, tax_conditions, transaction_types'
      )
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('The name of the catalog item')
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('A brief description of the catalog item')
    },
    {
      key: 'external_id',
      label: vm.$gettext('External ID'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('ID for this catalog item into the ERP')
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country ISO Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Country (2 letter ISO code) to which this entry belongs to')
    }
  ],
  filters: ['id', 'catalog', 'name', 'external_id', 'country_iso_code']
})

export default accountingCatalogsModel
